import React from 'react';

import { MobileFilterWrapper } from '@/modules/CarsStock/components/common.styles';
import StockFilterRange from '@/components/StockFilterRange';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarMileage,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';

function MileageFilter() {
  const dispatch = useTypedDispatch();
  const selectedMileage =
    useTypedSelector(getSelectedFilters).selectedParams.selectedMileage;

  const handleBlurMileage = (mileage: RangeType) => {
    dispatch(setCarMileage(mileage));
    dispatch(setPage(1));
  };

  return (
    <MobileFilterWrapper>
      <StockFilterRange
        label="Пробег, км"
        values={selectedMileage}
        onBlur={handleBlurMileage}
      />
    </MobileFilterWrapper>
  );
}

export default MileageFilter;
